import React, { Fragment, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import DingBell from "./../assets/audios/note_sms.mp3";
import Fab from "@material-ui/core/Fab";

import socket from "../utils/socket";
import App_Routes from "../routes/appRoutes";

import {
  setForumReadComments,
    setTicketCount,
  setForumReadTopics,
  updateUnreadChatCountAdmin,
  updateUnreadErxOfflineCount
} from "../reduxStore/actions/serverConstants";
import { updateDoctorsInQueue, updatePatientsInQueue } from "../reduxStore/actions/queueCount";

let isAdminJoinedSocket = false;

const SocketHandler = (props) => {
    const [muteAudio, setMuteAudio] = useState(true);
    // if socket connection error (We listen to server ping and pong events here in certain interval time)
    const [socketConnectionError, setSocketConnectionError] = useState(true);
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(props.auth && props.auth.isLoggedIn ? props.auth.isLoggedIn : false);
    // const [isAdminJoinedSocket, setIsAdminJoinedSocket] = useState(false);
    // socket connection timeout
    // const [socketConnectionTimeout, setSocketConnectionTimeout] = useState(0);
    // const socketConnectionTimeout = useRef(null);

    const handleSocketEvents = () => {
        socket.on("connect", function () {
            console.log("Admin Socket Connected");
            //TODO - listen for the JOINED event and once admin/support join the socket, update the reducer. Default when refresh or login, isAdminJoined: should be false
            socket.emit('join', "ADMINS");
            setSocketConnectionError(false);
            // setIsAdminJoinedSocket(true);
            isAdminJoinedSocket = true;
        });

        socket.on("disconnect", reason => {
            setSocketConnectionError(true);
            // setIsAdminJoinedSocket(false);
            isAdminJoinedSocket = false;

            console.log(
                "Server disconneted or internet lost, trying to reconnect", props.auth
            );
        });

        socket.on("UNREAD_CHAT_COUNT_ADMIN",  (data) => {
            props.updateUnreadChatCountAdmin(data);
            playAudio();
        });

        socket.on("FORUM_COMMENT_ADDED", (data) => {
          if (props.auth?.user?._id !== data.ignoreUser) {
            const unreadComments = props.serverConstants.forumReadComments ? +props.serverConstants.forumReadComments : 0;
            props.setForumReadComments(unreadComments + 1);
          }
        });

        socket.on("TICKET_ADMIN_ACTION_REQUIRED", (data) => {
            if (props.user.userType !== "SUPPORT_STAFF") {
                let count = 0;
                for (const userId in data) {
                    count += data[userId];
                }
                props.setTicketCount(count);
            } else {
                props.setTicketCount(data[props.user?._id] || 0);
            }
        });

        socket.on("FORUM_POST_ADDED", data => {
          if (props.auth?.user?._id !== data.ignoreUser) {
            const unreadTopics = props.serverConstants.forumReadTopics ? +props.serverConstants.forumReadTopics : 0;
            props.setForumReadTopics(unreadTopics + 1);
          }
        });

        socket.on("E_PRESCRIPTION_FAIL", data => {
            props.updateUnreadErxOfflineCount(data.count);
        });

        socket.on("FIRST_PATIENT_WAITING_FOR_LONG_TIME", data => {
            playAudioAnyway();
        })

        socket.on("PATIENT_HOME_PAGE_DATA", data => {
            if (data.queueData && data.queueData.queue) {
                // Patient status === 1 i.e Patient is in QUEUEING state.
                data.queueData.queue = data.queueData.queue.filter(item => item.status === 1);
            }
            updateQueueCountOnTopNav(data);
        })

        socket.on("message", (data) => {
            console.log("Got the data: ", data);
            // once you connected and received message like {message: You have joined ------, isAdminJoined: true} then mark in redux
            let jsonData;
            try {
                // try to parse the data because server sometimes parse string values as object. So, we need to convert it. If doesn't parse the data that means we already have json data
                jsonData = JSON.parse(data);
            } catch (e) {
                jsonData = data;
            }

            // SERVER_PONG event is to check the you have connection with backend. If you don't receive this event in interval then there is connection issue with socket
            // if (jsonData && jsonData.type === "SERVER_PONG") {
            //     handleServerPong();
            // }
        })
    }

    // const checkSocketConnection = async () => {
    //     setTimeout(() => {
    //         socket.emit("serverping", socket.id);
    //     }, 2000);
    //     setInterval(() => {
    //         console.log("** Check Socket Connection **");
    //         console.log("Is socket connected?", socket.connected);
    //         socket.emit("serverping", socket.id);
    //         if (!socket.connected) {
    //             setSocketConnectionError(true);
    //         }
    //     }, APP_CONTANTS.SOCKET_PING_PONG_INTERVAL);
    // }

    // const handleServerPong = async () => {
    //     console.log("Handle server pong");
    //     clearTimeout(socketConnectionTimeout.current);
    //     setSocketConnectionError(false);
    //     socketConnectionTimeout.current = setTimeout(() => {
    //         console.log("Setting pong interval to true");
    //         setSocketConnectionError(true);
    //     }, APP_CONTANTS.SOCKET_PING_PONG_INTERVAL);
    // }

    const playAudio = () => {
        if (window.location.pathname !== App_Routes.supportChat || !props.muteVolume) {
            const audioEl = document.getElementsByClassName("chat-audio-ele")[0];
            if (audioEl) audioEl.play();
        }
    };

    const playAudioAnyway = () => {
        const audioEl = document.getElementsByClassName("audio-element-anyway")[0];
        if (audioEl) audioEl.play();
    };

    const updateQueueCountOnTopNav = (data) => {
        console.log("Update for top nav: ", data);
        props.updatePatientsInQueue(data.queueData.queue.length);
        const doctorData = {
            connectedDoctors: data.doctorSocketsConnected,
            icDoctorCount: data.queueData.onlineDoctorCount
        }
        props.updateDoctorsInQueue(doctorData);
    }

    const checkSocketConnection = () => {
        const loggedInUserData = props.auth && props.auth.user ? props.auth.user : null;
        // const isUserLoggedIn = props.auth && props.auth.isLoggedIn ? props.auth.isLoggedIn : false;
        console.log("checkSocketConnection: isSocketNotConnected? isUserLoggedIn? userLoggedInData? ", !socket.connected && loggedInUserData && isUserLoggedIn, !socket.connected, isUserLoggedIn, loggedInUserData);
        if (!socket.connected && loggedInUserData && isUserLoggedIn) {
            console.log("User is logged in but socket is not connected");
            socket.connect();
            setSocketConnectionError(true);
        } else if (!socket.connected && !isUserLoggedIn) {
            console.log("Disconnecting user because not authorised");
            socket.disconnect();
        } else if (socket.connected && !isAdminJoinedSocket) {
            socket.emit('join', "ADMINS");
            // setIsAdminJoinedSocket(true);
            isAdminJoinedSocket = true;
        }
    }

    useEffect(() => {
        console.log("Socket Handler Loaded");
        handleSocketEvents();
        checkSocketConnection();

        let pathName = window.location.pathname;
        if (App_Routes.supportChat !== pathName && props.isMuted === false) {
            setMuteAudio(false);
        } else {
            setMuteAudio(true);
        }

        console.log("pathName: " + pathName);

        return () => {
            console.log("Socket handler unmounted");
            setIsUserLoggedIn(false);
            socket.disconnect();

        }
    }, []);

    return (
        <Fragment>
            <Fab
                size="medium"
                color="secondary"
                aria-label="socket-connection"
                className={socketConnectionError ? "socket-connection-fab" : "d-none"}
            >
                <i className="fas fa-exclamation"></i>
            </Fab>
            <audio className="audio-element d-none" muted={muteAudio}>
                <source src={DingBell}></source>
            </audio>
            <audio className="audio-element-anyway d-none">
                <source src={DingBell}></source>
            </audio>
        </Fragment>
    )
}

const mapStateToProps = state => ({
    auth: state.auth,
    isMuted: state.serverConstants.isMuted,
    serverConstants: state.serverConstants
});

const mapDispatchToProps = dispatch => ({
    updateUnreadChatCountAdmin: data => dispatch(updateUnreadChatCountAdmin(data)),
    setForumReadTopics: data => dispatch(setForumReadTopics(data)),
    setForumReadComments: data => dispatch(setForumReadComments(data)),
    setTicketCount: data => dispatch(setTicketCount(data)),
    updateUnreadErxOfflineCount: data => dispatch(updateUnreadErxOfflineCount(data)),
    updatePatientsInQueue: data => dispatch(updatePatientsInQueue(data)),
    updateDoctorsInQueue: data => dispatch(updateDoctorsInQueue(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(SocketHandler);
